var availableCollections;
var availableCollectionsArray;
var availableCollectionsArrayLength = 0;
var availableCollectionsLoadCount = 0;
var jsonOptions = '';
var colorData = {};
var colorSelectorDataList;
var colorSelectorInput;
var colorSelectorContainer;
var currentColorCollections = '';

function loadJSONOptions (collection) {
  if(collection) {
    getColorCollection('/collections/' + collection + '?view=colors',collection);
  }
}

function updateColorOptions(variant_id) {
  colorSelectorDataList = document.getElementById('colors-datalist');
  colorSelectorInput = document.getElementById('color');
  colorSelectorContainer = document.getElementById('color-selector');
  if(colorSelectorContainer) {
    colorSelectorContainer.classList.remove('hidden');
    colorSelectorInput.classList.add('required');
    setupColorSelectorInput();
    colorSelectorInput.required = true;
    if (typeof variantColorCollections !== 'undefined') {
      if(variantColorCollections[variant_id] && variantColorCollections[variant_id].length) {
        availableCollections = variantColorCollections[variant_id];
      } else {
        availableCollections = productColorCollections;
      }
      if (typeof availableCollections !== 'undefined') {
        if(availableCollections !== currentColorCollections) {
          currentColorCollections = availableCollections;
          availableCollectionsArray = availableCollections.split('|');
          availableCollectionsLoadCount = 0;
          availableCollectionsArrayLength = availableCollectionsArray.length;
          jsonOptions = '';
          colorSelectorDataList.innerHTML = '';
          clearColor();
          colorSelectorInput.placeholder = "Search colour";
          if(sessionStorage.getItem('colorData')) {
            colorData = JSON.parse(sessionStorage.getItem('colorData'));
          }
          loadJSONOptions(availableCollectionsArray[0]);
        }
      }
      if(availableCollections == '') {
        colorSelectorContainer.classList.add('hidden');
        colorSelectorInput.classList.remove('required');
        colorSelectorInput.required = false;
      }
    }
  }
}

function createOptions(item) {
  var optionElement = document.getElementById(item.handle);
  if (optionElement === null) {
    var option = document.createElement('option');
    option.id = item.handle;
    option.value = item.title;
    colorSelectorDataList.appendChild(option);
  }  
}

function clearColor() {
  colorSelectorInput.value = '';
  var colorSwatch = document.querySelector('span.color-swatch');
  colorSwatch.style.backgroundImage = 'none';
  var colorSwatchLink = document.querySelector('a.color-swatch-link');
  colorSwatchLink.href = '';
}

function getColorCollection(collection_url,collection) {
  if (colorData[collection]) {
    addColorSelectorOptions(collection);
  } else {
    preloadDefaultColorCollections(collection_url,collection);
  }
}

function addColorSelectorOptions(collection) {
  if (typeof colorData[collection] !== 'undefined') {
    for (const [key, value] of Object.entries(colorData[collection])) {
      var item = {};
      item.handle = Object.keys(value)[0];
      item.title = Object.values(value)[0];
      createOptions(item);
    }
  }
  if(availableCollectionsArrayLength-1 > availableCollectionsLoadCount) {
    availableCollectionsLoadCount++;
    loadJSONOptions(availableCollectionsArray[availableCollectionsLoadCount]);
  }
}

function setupColorSelectorInput() {
  colorSelectorInput = document.getElementById('color');
  if (colorSelectorInput) {
    //Update Color Swatch
    colorSelectorInput.addEventListener('change', (event) => {
      var targetErrors = event.target.parentNode.querySelector('div.errors');
      if (targetErrors !== null) {
        targetErrors.parentNode.removeChild(targetErrors);
      }
      var selectedProduct = document.querySelector('#colors-datalist option[value="'+event.target.value+'"]');
      if (selectedProduct == null) {
        event.target.value = '';
      } else {
        var selectedProductID = selectedProduct.getAttribute('id');
        var apiURL = '/products/' + selectedProductID + '.js';
        var request = new XMLHttpRequest();
        request.onreadystatechange = function(response) {
          if (request.readyState === 4) {
            if (request.status === 200) {
              var colorMeta = JSON.parse(request.responseText);
              var selectedProductImage = colorMeta.featured_image;
              var colorSwatch = document.querySelector('span.color-swatch');
              var colorSwatchLink = document.querySelector('a.color-swatch-link');
              if(selectedProductImage == 'null') {
                colorSwatch.style.backgroundImage = 'none';
                colorSwatchLink.href = '#';
                colorSwatchLink.classList.add('disabled');
              } else {
                colorSwatch.style.background = "url('"+selectedProductImage+"')";
                colorSwatchLink.href = '/products/' + selectedProductID;
                colorSwatchLink.classList.remove('disabled');
              }
            } else {

            }
          }
        };
        request.open('GET', apiURL, true);
        request.send();
      }
    });

    colorSelectorInput.addEventListener('focusin', (event) => {
      clearColor();
    });
  }
}
setupColorSelectorInput();

// Preload default color collections
var defaultColorCollectionsArray = [];
var defaultColorCollectionsArrayLength = 0;
var defaultColorCollectionsLoadCount = 0;
var documentLang = document.documentElement.lang;

if(sessionStorage.getItem('defaultColorCollectionsArray')) {
  defaultColorCollectionsArray = JSON.parse(sessionStorage.getItem('defaultColorCollectionsArray'));
} else if(documentLang == 'en-US') {
  defaultColorCollectionsArray = ['bmc','cp','af','cc','csp','ac','hc','oc','cw'];
} else if(documentLang == 'en-CA') {
  defaultColorCollectionsArray = ['benjamin-moore-classics','colour-preview','affinity-colour-collection','designer-classics','aura-colour-stories','historical-colours','off-white-colours'];
} else {
  defaultColorCollectionsArray = ['bmc','cp','af','cc','csp','ac','hc','oc','cw','benjamin-moore-classics','colour-preview','affinity-colour-collection','designer-classics','aura-colour-stories','historical-colours','off-white-colours'];
}

window.addEventListener('load', (event) => {
  defaultColorCollectionsLoadCount = 0;
  defaultColorCollectionsArrayLength = defaultColorCollectionsArray.length;
  preloadDefaultColorCollectionsURL(defaultColorCollectionsArray[0]);
});

function preloadDefaultColorCollectionsURL (collection) {
  if(collection) {
    if(sessionStorage.getItem('colorData')) {
      colorData = JSON.parse(sessionStorage.getItem('colorData'));
      if(!colorData[collection]) {
        preloadDefaultColorCollections('/collections/' + collection + '?view=colors',collection);
      } else {
        defaultColorCollectionsLoadCount++;
        preloadDefaultColorCollectionsURL(defaultColorCollectionsArray[defaultColorCollectionsLoadCount]);
      }
    } else {
      preloadDefaultColorCollections('/collections/' + collection + '?view=colors',collection);
    }
  }
}

function preloadDefaultColorCollections(collection_url,collection) {
  var apiURL = collection_url;
  var request = new XMLHttpRequest();
  request.onreadystatechange = function(response) {
    if (request.readyState === 4) {
      if (request.status === 404) {
        var collectionIndex = defaultColorCollectionsArray.indexOf(collection);
        if (collectionIndex > -1) {
          defaultColorCollectionsArray.splice(collectionIndex, 1);
        }
        sessionStorage.setItem('defaultColorCollectionsArray', JSON.stringify(defaultColorCollectionsArray));
      }
      if (request.status === 200) {
        jsonOptions = JSON.parse(request.responseText);
        jsonColors = jsonOptions.colors;
        jsonNextPage = jsonOptions.nextpage;
        jsonColors.forEach(function(item) {
          if (!colorData[collection]) {
            colorData[collection] = [];
          }
          itemObject = {};
          itemObject[item.handle] = item.title;
          colorData[collection].push(itemObject);
        });
        if(jsonOptions.nextpage !== '') {
          preloadDefaultColorCollections(jsonNextPage,collection);
        } else {
          if(defaultColorCollectionsArrayLength-1 > defaultColorCollectionsLoadCount) {
            defaultColorCollectionsLoadCount++;
            preloadDefaultColorCollectionsURL(defaultColorCollectionsArray[defaultColorCollectionsLoadCount]);
          } else {
            sessionStorage.setItem('colorData', JSON.stringify(colorData));
            loadJSONOptions(availableCollectionsArray[0]);
          }
        }
      } else {
        if(defaultColorCollectionsArrayLength-1 > defaultColorCollectionsLoadCount) {
          defaultColorCollectionsLoadCount++;
          preloadDefaultColorCollectionsURL(defaultColorCollectionsArray[defaultColorCollectionsLoadCount]);
        }
      }
    }
  };
  request.open('GET', apiURL, true);
  request.send();
}
